<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @updateCdValue="getCodeList" @updateCodeDesc="getCodeList" @deleteCode="getCodeList" @registCode="getCodeList"></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="3" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="3" :currentTab2="1" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit003">
                  <div class="tb-header clear">
                    <SelectBox
                        v-model="selectedTenantId"
                        valueProp = "tenantId"
                        textProp = "tenantName"
                        :disabled="view.disabled"
                        :excludes="view.selectExcludes"
                        div-cls="selectDiv"
                        :dtl-cd-list="codes.selectList"
                        style="float: left; margin-top: 6px; margin-right: 20px;">
                    </SelectBox>
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>
                      <div class="btnDiv fr">
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="codeSetting('regist')"
                      >
                        {{$i18nUtil.trans("message.CodeSetting.001","코드 등록")}}
                      </button>
                    </div>
                      <div class="search_ty2" style="float: right;padding-right: 20px;">
                        <input
                          type="text"
                          required
                          :placeholder="$i18nUtil.trans('message.CodeList.001','코드 설명 검색')"
                          v-model="searchUser"
                          @keyup.enter="[changePage(), getCodeList()]"
                        />
                        <button
                          type="button"
                          class="input-txt"
                          @click="[changePage(), getCodeList()]"
                        >
                        {{$i18nUtil.trans("search.039","검색")}}
                        </button>
                      </div>
                  </div>

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="codeList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div>
                            <span class="ell-singleline d-block cursor-pointer" @click="codeSetting(item)" >
                              {{ item.cdCategory }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="ell-singleline d-block cursor-pointer" @click="codeSetting(item)">
                              {{ item.cdKey }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.cdValue }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.codeDesc }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.deleteYn }}</span>
                          </div>
                        </td>
                      </tr>
                    </template>

                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          {{$i18nUtil.trans("message.CodeList.002","코드 리스트가 없습니다.")}}
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getCodeList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import CodeSetting from "./modal/CodeSetting";
import SelectBox from "./common/SelectBox";

export default {
  components: {
    AuditSubTab,
    AuditTab,
    CodeSetting,
    SelectBox,
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      selectedTenantId : "",
      view : {
          selectExcludes : [],
          disabled : false
      },
      codes : {
          selectList : []
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("message.CodeList.003","카테고리"), value: "cdCategory", align: "center", sortable: false },
        { text: this.$i18nUtil.trans("message.CodeManage.002","코드키"), value: "cdKey", sortable: false },
        { text: this.$i18nUtil.trans("message.CodeManage.003","코드값"), value: "cdValue", sortable: false },
        { text: this.$i18nUtil.trans("message.CodeManage.004","코드설명"), value: "codeDesc", sortable: false },
        { text: this.$i18nUtil.trans("message.CodeManage.005","삭제여부")+"(1:Y/0:N)", value: "deleteYn", sortable: false },
      ],
      codeList: [],
      searchUser: "",
      authorize: "",
    };
  },
  created() {
    this.getTenantList();
  },
  watch: {
    'selectedTenantId' : function() {
        this.getCodeList();
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    /* 테넌트 리스트 조회 */
    getTenantList() {
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.url = "/api/org/statistics/getTenantList";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {
            obj.selectedTenantId = "DEFAULT";
            obj.codes.selectList = res.result.tenantInfoList;
            obj.codes.selectList.unshift({"tenantName":"DEFAULT","tenantId":"DEFAULT"});
            obj.getCodeList();
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 코드 리스트 조회 */
    getCodeList() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
        searchUser: obj.searchUser,
        tenantId: obj.selectedTenantId
      };
      reqData.url = "/api/org/code/getCodeList";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
            obj.authorize = res.errorCode;
          } else {
            obj.codeList = res.result.codeList;
            obj.totalCount = res.result.codeCount;
            obj.pageCount = res.result.codePageCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    codeSetting(item) {
      if(this.authorize != "NOT_AUTHORIZED"){
        if(item == 'regist'){
          const modalInfo = {
          obj: this.$modal,
          component: CodeSetting,
          width: "1220px",
          height: "665px",
          status: item,
          tenantId: this.selectedTenantId,
        };
        this.showModal(modalInfo);
        }else{
          const modalInfo = {
          obj: this.$modal,
          component: CodeSetting,
          width: "1220px",
          height: "665px",
          target : item,
          // cdCategory: item.cdCategory,
          // cdKey: item.cdKey,
          // cdValue: item.cdValue,
          // codeDesc: item.codeDesc,
          // deleteYn: item.deleteYn,
          tenantId: this.selectedTenantId,
          };
        this.showModal(modalInfo);
        }
      }
    },  
    changePage() {
      this.page = 1;
    },
  },
};
</script>

<style scoped>
.audit003 {
  margin-top: 38px;
}
.audit003 >>> th:nth-child(1),
.audit003 >>> td:nth-child(1) {
  text-align: left;
  width: 200px !important;
}
.audit003 >>> th:nth-child(2),
.audit003 >>> td:nth-child(2) {
  text-align: left;
  width: 200px !important;
}
.audit003 >>> th:nth-child(3),
.audit003 >>> td:nth-child(3) {
  text-align: left;
  width: calc(100% - 200px - 200px - 320px - 150px) !important;
}
.audit003 >>> th:nth-child(4),
.audit003 >>> td:nth-child(4) {
  text-align: left;
  width: 320px !important;
}
.audit003 >>> th:nth-child(5),
.audit003 >>> td:nth-child(5) {
  text-align: center;
  width: 150px !important;  
}
.audit003 >>> input {
  background-color: transparent;
}
.audit003 >>> th:nth-child(1) > span {
  margin-left: 50px;
}
.audit003 >>> th:nth-child(2) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(3) > span {
  margin-left: 10px;
}
.audit003 >>> th:nth-child(4) > span {
  margin-left: 10px;
}
.audit003 >>> td:nth-child(1) > div > span {
  text-align: left;
  margin-left: 50px;
  width: 150px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(2) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 170px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(3) > div > span {
  text-align: left;
  margin-left: 10px;
  width: 290px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(4) > div > span {
  margin-left: 10px;
  width: 310px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}

</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/CodeList.vue